import { takeLatest, put, select } from 'redux-saga/effects';
import { logger } from 'services';
import { getMembers } from '../actions';
import { MembersAPI } from '../api';
import { setMembersLoading, setMembersError, setMembers } from '../slice';
function* getMembersManager() {
    try {
        const isMembersLoaded = yield select((state)=>state.members.loadedAllMembers);
        if (!isMembersLoaded) {
            yield put(setMembersLoading(true));
        }
        const { teams = [], users = [], members = [] } = yield MembersAPI.findAll();
        yield put(setMembers({
            teams,
            users,
            members
        }));
    } catch (error) {
        logger.error('members findAll failed', {
            error
        });
        yield put(setMembersError(true));
    } finally{
        yield put(setMembersLoading(false));
    }
}
export const watchGetMembers = function*() {
    yield takeLatest(getMembers.type, getMembersManager);
};
